<ng-container *transloco="let convert;">
  <app-modal [modalId]="modalId">

    <ng-container class="modal_container">
      <header class="modal__header">
        @if (auctionFeeScheduleName) {
          <h1 class="modal__title" id="service-fee-modal-title"  [attr.id]="modalId + '-title'" tabindex="-1">
            <strong>{{auctionFeeScheduleName}} {{ convert('shared.serviceFeeScheduleModal.textServiceFeeSchedule') }}</strong>
          </h1>
        }
        @if (!auctionFeeScheduleName) {
          <h1 class="modal__title" id="service-fee-modal-title"  [attr.id]="modalId + '-title'" tabindex="-1">
            <strong>{{ convert('shared.serviceFeeScheduleModal.textStandardServiceFeeSchedule') }}</strong>
          </h1>
        }
      </header>
      <p>{{ convert('shared.serviceFeeScheduleModal.summaryServiceFeeSchedule') }}</p>
      <p>{{ convert('shared.serviceFeeScheduleModal.headingServiceFee') }}</p>

      <section class="service-fee-table">
        <app-table>
          <table
            cdk-table
            [dataSource]="datasource"
            [attr.aria-label]="convert('shared.serviceFeeScheduleModal.ariaLabelServiceFeeTier')"
            >
            <ng-container cdkColumnDef="openingPrice" class="left-column">
              <th cdk-header-cell id="opening-price-column-header" *cdkHeaderCellDef>{{ convert('shared.serviceFeeScheduleModal.textOpeningPrice') }}</th>
              <td cdk-cell *cdkCellDef="let tier">
                @if (tier.openingPrice) {
                  {{tier.openingPrice}}
                } @else {
                  {{convert('shared.serviceFeeScheduleModal.textGreaterThan')}} {{ maxPriceAmount | currency: 'USD':'symbol':'1.0-0' }}
                }

              </td>
            </ng-container>
            <ng-container cdkColumnDef="serviceFee" class="right-column">
              <th cdk-header-cell id="fee-amount-column-header" class="text-start" *cdkHeaderCellDef>{{ convert('shared.serviceFeeScheduleModal.textFeeAmount') }}</th>
              <td cdk-cell class="text-start" *cdkCellDef="let tier">
                {{tier.feeAmount}}
              </td>
            </ng-container>
            <tr cdk-header-row class="table-header-row" *cdkHeaderRowDef="['openingPrice', 'serviceFee']"></tr>
            <tr cdk-row class="table-row" *cdkRowDef="let row; columns: ['openingPrice', 'serviceFee']"></tr>
          </table>
        </app-table>
      </section>
      <p style="border-top: 2px solid #f2f2f2;">{{ convert('shared.serviceFeeScheduleModal.textAdjustServiceFee') }}</p>

      <div class="modal__action">
        <button
          class="btn btn-primary"
          (click)="closeModal()"
          data-track-elem="button"
          data-track-name="close"
          data-track-trigger="close"
          id="close_button"
          >
          {{ convert('common.btnClose') }}
        </button>
      </div>

      <div class="modal-close-container">
        <button
          class="modal__close"
          [attr.aria-label]="convert('common.modalClose')"
          (click)="closeModal()"
          data-track-elem="icon"
          data-track-name="Close"
          data-track-trigger="close"
          id="do_close_x_button"
          >
          <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
        </button>
      </div>
    </ng-container>

  </app-modal>
</ng-container>
